export default __webpack_public_path__ + "static/media/award01.361a4bc4.png";